// SAM-1312 (U19, U25): what Estates offers each role. The estate group roles never see Hik-Connect (internal data), the estate
// group front desk only views, and an empty state never sends anyone to a button their role does not have.

export const showHikConnect = (hikEnabled: boolean, p: { isEstateGroupAdmin?: boolean; isEstateGroupFrontDesk?: boolean }): boolean =>
  hikEnabled && !p.isEstateGroupAdmin && !p.isEstateGroupFrontDesk;

export const noBuildingsText = (canAdd: boolean): string =>
  canAdd ? 'No buildings yet — click Add to create one' : 'No buildings yet';

export const selectHint = (canEdit: boolean): string =>
  `Select a group, building, or estate to ${canEdit ? 'edit' : 'view'}`;

type Opt = { id: number | string; label: string };

/**
 * SAM-1320 (U25): Type and Status showed empty when an estate carried a value outside the fixed lists (the selects
 * only list what they know). The stored value is added as its own option so it is shown, never blanked.
 */
export const withStoredOption = (options: Opt[], stored: number | string | null | undefined, labelOf: (v: number | string) => string): Opt[] =>
  stored === null || stored === undefined || stored === '' || options.some((o) => o.id === stored)
    ? options
    : [...options, { id: stored, label: labelOf(stored) }];

export const storedTypeLabel = (id: number | string): string => `Type ${id}`;

export const storedStatusLabel = (v: number | string): string => {
  const s = String(v).replace(/[_-]+/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
};

/** Placeholder of a Type / Status select: a role that cannot edit sees a dash, not an invitation to pick. */
export const selectPlaceholder = (canEdit: boolean, ask: string): string => (canEdit ? ask : '—');
